import './index.scss'
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";

function init(scope = document) {
    const nodeSelectors = {
        container: '[js-gallery="container"]',
        sliderContainer: '[js-gallery="slider-container"]',
        slider: '[js-gallery="slider"]',
        sliderNext: '[js-gallery="slider-next"]',
        sliderPrev: '[js-gallery="slider-prev"]',
    }

    const containers = scope.querySelectorAll(nodeSelectors.container)

    if (!containers.length) return

    function isVideoSlide(slide) {
        return slide.dataset.type === 'video'
    }

    function loadVideo(slide) {
        if (!slide || !isVideoSlide(slide)) return

        const src = slide.dataset.videoSrc
        const mediaHolder = slide.querySelector('.media-holder')

        if (!src || !mediaHolder || mediaHolder.querySelector('iframe')) return

        const iframe = document.createElement('iframe')
        iframe.src = src
        iframe.setAttribute('allowfullscreen', '')
        iframe.setAttribute('allow', 'encrypted-media; picture-in-picture')
        iframe.setAttribute('loading', 'lazy')

        mediaHolder.appendChild(iframe)
    }

    function unloadVideo(slide) {
        if (!slide || !isVideoSlide(slide)) return

        const iframe = slide.querySelector('.media-holder iframe')

        if (iframe) {
            iframe.remove()
        }
    }

    function updateVideos(swiper) {
        swiper.slides.forEach((slide) => {
            unloadVideo(slide)
        })

        loadVideo(swiper.slides[swiper.activeIndex])
    }

    containers.forEach((container) => {
        const sliderContainer = container.querySelector(nodeSelectors.sliderContainer);

        if (!sliderContainer) return

        const sliderEl = sliderContainer.querySelector(nodeSelectors.slider);

        if (!sliderEl) return

        if (sliderEl.swiper) {
            sliderEl.swiper.destroy(true, true);
        }

        const settings = {
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            speed: 400,
            allowTouchMove: true,
            navigation: {
                nextEl: container.querySelector(nodeSelectors.sliderNext),
                prevEl: container.querySelector(nodeSelectors.sliderPrev),
            },
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
            on: {
                init(swiper) {
                    updateVideos(swiper)
                },
                slideChangeTransitionEnd(swiper) {
                    console.log('slideChangeTransitionStart')
                    updateVideos(swiper)
                },
            },
        };

        new Swiper(sliderEl, settings);
    })
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=gallery', ($block) => {
            const blockEl = $block[0] || $block;
            init(blockEl);
        });
    } else if (!isGutenbergEditorVisible()) {
        init()
    }
});